import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 15000,
});

export const endpoints = {
    userImpact: (userId = "demo-user") => `/user/impact?user_id=${userId}`,    community: () => "/community/impact",
    communityBattery: () => "/community/battery",
    milestones: (userId = "demo-user") => `/milestones?user_id=${userId}`,
    allocation: () => "/impact/allocation",
    pricing: () => "/pricing",
    causes: () => "/causes",
    userCause: (userId = "demo-user") => `/user/cause?user_id=${userId}`,
    setUserCause: () => "/user/cause",
    batteryImpact: () => "/battery/impact",
    sponsors: () => "/sponsors",
    sponsorCurrent: () => "/sponsors/current",
    setSponsorCurrent: () => "/admin/sponsor-current",
    downloads: () => "/downloads",
    logDownload: () => "/downloads",
    annualReport: (userId = "demo-user") => `/report/annual?user_id=${userId}`,
    referrals: (userId = "demo-user") => `/referrals?user_id=${userId}`,
    redeemReferral: () => "/referrals/redeem",
    blogPosts: () => "/blog/posts",
    blogPost: (slug) => `/blog/posts/${slug}`,
    partnerAttribution: (slug) => `/partners/${slug}/attribution`,
    founderProfile: (number) => `/impact/founder/${number}`,
    communityWall: () => "/community/wall",
    communityWallOptIn: () => "/community/wall/opt-in",
    communityWallOptOut: () => "/community/wall/opt-out",
    communityWallStatus: (userId) => `/community/wall/status?user_id=${userId}`,
    ssoStatus: () => "/auth/sso/status",
    ssoVerify: () => "/auth/sso/verify",
    sponsorLeadCreate: () => "/partners/leads",
    sponsorLeadsList: (token) => `/partners/leads?admin_token=${encodeURIComponent(token)}`,
};

// Marketing site URL (EVIQ Pro). Configurable per environment.
export const MARKETING_URL =
    process.env.REACT_APP_MARKETING_URL || "https://eviq.pro";
